import { EntityLayout } from "@backstage/plugin-catalog";
import { Grid } from "@material-ui/core";
import React from "react";

import { CustomEntityLayout } from "../../../pages/EntityLayout";

export const groupInfoPage = (entityWarningContent: JSX.Element) => (
    <CustomEntityLayout>
      <EntityLayout.Route path="/" title="Overview">
        <Grid container spacing={3}>
          {entityWarningContent}
        </Grid>
      </EntityLayout.Route>
    </CustomEntityLayout>
  );